// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  align-self: stretch;
  border-radius: 10px;
  background: var(--Grey-scale-White, #FFF);
  width: 100%;
}
:host::ng-deep .read-more-btn {
  margin: 12px 0 0 !important;
}
:host::ng-deep .read-more-btn p {
  line-height: 20px !important;
  font-size: 16px !important;
}
:host::ng-deep .read-more-body-expanded .rating-description {
  -webkit-line-clamp: none;
  display: block;
  -webkit-box-orient: vertical;
}

.rating-points-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 8px;
}

app-product-compact-rating-points {
  color: var(--Supervin-colors-Orange, #FF9812);
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
}

.previous-vintage-text {
  color: var(--Grey-scale-Lighter-text, #696969);
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px; /* 156.25% */
}

.rating-name {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 0;
}

.rating-description {
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 25px;
  -webkit-line-clamp: 4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/product/components/product-ratings-section/product-rating/product-rating.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,WAAA;AACF;AAEI;EACE,2BAAA;AAAN;AAEM;EACE,4BAAA;EACA,0BAAA;AAAR;AAKM;EACE,wBAAA;EACA,cAAA;EACA,4BAAA;AAHR;;AASA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AANF;;AASA;EACE,6CAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,8CAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;AAPF","sourcesContent":[":host {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 5px;\n  align-self: stretch;\n  border-radius: 10px;\n  background: var(--Grey-scale-White, #FFF);\n  width: 100%;\n\n  &::ng-deep {\n    .read-more-btn {\n      margin: 12px 0 0 !important;\n\n      p {\n        line-height: 20px !important;\n        font-size: 16px !important;\n      }\n    }\n\n    .read-more-body-expanded {\n      .rating-description {\n        -webkit-line-clamp: none;\n        display: block;\n        -webkit-box-orient: vertical;\n      }\n    }\n  }\n}\n\n.rating-points-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0 8px;\n}\n\napp-product-compact-rating-points {\n  color: var(--Supervin-colors-Orange, #FF9812);\n\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25px;\n}\n\n.previous-vintage-text {\n  color: var(--Grey-scale-Lighter-text, #696969);\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px; /* 156.25% */\n}\n\n.rating-name {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  margin-bottom: 0;\n}\n\n.rating-description {\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 25px;\n  -webkit-line-clamp: 4;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
